import React from 'react';

import { SiteUrlsProps } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { Messages } from '~src/codegen/Localize';
import { ItemDescription } from '~src/spacesPlatform/components/header/HeaderItemDescription';
import { OwnerMetadata } from '~src/spacesPlatform/components/header/HeaderMetadataRow';
import { ActionsMenuIcon, DetailButtonIcon, FavoriteToggleWithCountsIcon } from '~src/spacesPlatform/components/header/HeaderNameRowIcons';
import { ConnectedSpaceHeader } from '~src/spacesPlatform/components/header/SpaceHeader';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';

export interface ProjectSpaceHeaderProps extends SiteUrlsProps {
  readonly item: ISpaceItemDetailInfo<'project'>;
  readonly openDetail: () => void;
  readonly addToFavorites: () => void;
  readonly removeFromFavorites: () => void;
  readonly selectedContentItemsCount: number;
}

export function ProjectSpaceHeader(props: ProjectSpaceHeaderProps): JSX.Element {
  const actionsMenuDisabled = props.selectedContentItemsCount > 0;
  const actionsMenuButtonTitle = actionsMenuDisabled ? Messages.projectActionsMenuDisabled() : null;

  return <ConnectedSpaceHeader
      item={props.item}
      showToolbar={true}
      detailIcons={
        <React.Fragment>
          { FavoriteToggleWithCountsIcon({
            item: props.item,
            addToFavorites: props.addToFavorites,
            removeFromFavorites: props.removeFromFavorites,
          }) }
          { DetailButtonIcon(props.item, props.openDetail) }
          { ActionsMenuIcon(props.item, actionsMenuDisabled, actionsMenuButtonTitle) }
        </React.Fragment>
      }
      metadataElement={ OwnerMetadata(props.item.owner, props.urls) }
      descriptionElement={<ItemDescription item={props.item}/>}
  />;
}
